<template>
    <div>
        <b-modal
            no-close-on-esc
            no-close-on-backdrop
            size="xl"
            hide-footer
            v-model="showModal"
            :title="$t('dashboard.dashboardAlerts.checkOwsResultTitle')"
            scrollable
        >
            <b-container fluid v-if="!loading">
                <b-form-group :label="$t('dashboard.dashboardAlerts.labelOWS')">
                    <b-form-input
                        v-model="data.sourceName"
                        readonly
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    v-if="data.resultWMS"
                    :label="$t('dashboard.dashboardAlerts.labelWMS')"
                >
                    <b-form-input
                        v-model="data.resultWMS"
                        readonly
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    v-if="data.resultWFS"
                    :label="$t('dashboard.dashboardAlerts.labelWFS')"
                >
                    <b-form-input
                        v-model="data.resultWFS"
                        readonly
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    v-if="data.resultWMTS"
                    :label="$t('dashboard.dashboardAlerts.labelWMTS')"
                >
                    <b-form-input
                        v-model="data.resultWMTS"
                        readonly
                    ></b-form-input>
                </b-form-group>
                <p>{{ $t('dashboard.dashboardAlerts.labelLayers') }}</p>
                <b-table
                    id="layerResults"
                    striped
                    hover
                    small
                    outlined
                    bordered
                    caption-top
                    :items="data.layerErrors"
                    :fields="fields"
                ></b-table>
            </b-container>
            <b-spinner
                v-else
                small
                class="mx-2"
                style="align-self: center"
                label="Loading"
            />
        </b-modal>
    </div>
</template>

<script>
    import modalMixin from '../../components/Mixins/ModalMixin.vue';

    export default {
        name: 'ows_check',

        mixins: [modalMixin],

        components: {},

        props: {
            launchModal: { type: Boolean, required: false, default: false },
            id: { type: Number }
        },

        data() {
            return {
                showModal: false,
                loading: false,
                data: '',
                fields: [
                    {
                        key: 'layerName',
                        label: this.$t('dashboard.dashboardAlerts.labelLayerName'),
                        sortable: true
                    },
                    {
                        key: 'result',
                        label: this.$t('dashboard.dashboardAlerts.labelResult'),
                        sortable: true
                    }
                ]
            };
        },

        methods: {
            async $_showModal() {
                this.data = '';
                this.showModal = true;
                this.loading = true;
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetSourceErrorReport',
                    parameters: { SourceId: this.id }
                });
                this.data = result.data;
                this.loading = false;
            }
        },

        watch: {
            launchModal() {
                this.$_showModal();
            }
        }
    };
</script>

